import React from 'react'
import {
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import MuiListItem from '@material-ui/core/ListItem'
import { styled, withStyles } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'

const ICON_CLASS = 'AppShellSidebarItem-icon'

// withStyles (not styled) is required here: MUI v4's styled() intercepts
// the polymorphic `component` prop and renders it directly, bypassing
// MuiListItem entirely. withStyles preserves MuiListItem's own rendering,
// including ButtonBase composition when `button` is true.
const ExtendedListItem = withStyles(theme => ({
  root: {
    '&.Mui-selected': {
      borderLeftStyle: 'solid',
      borderLeftColor: theme.palette.secondary.main,
      paddingLeft: '12px',
      borderLeftWidth: '4px',
    },
    '&.Mui-selected:hover': {
      borderLeftStyle: 'solid',
      borderLeftColor: theme.palette.secondary.main,
      borderLeftWidth: '4px',
    },
  },
}))(MuiListItem)

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 24 + theme.spacing(1),
  [`& .${ICON_CLASS}`]: {
    height: '24px',
    width: '24px',
  },
}))

export default function SidebarItem({
  icon,
  onClick,
  label,
  path,
  location,
  exact,
  annotation,
  disabled = false,
  external = false,
  hide = false,
  isTabletNavOpen,
}) {
  const iconComponent = React.cloneElement(icon, {
    className: ICON_CLASS,
  })

  const isBookingsPage =
    path.includes('bookings') &&
    location.pathname.includes('bookings') &&
    !location.pathname.includes('schedule') &&
    !path.includes('schedule') &&
    !location.pathname.includes('events')
  const isEventPage =
    path.includes('schedule') &&
    location.pathname.includes('events') &&
    !location.pathname.includes('offerings') &&
    !path.includes('offerings')

  const selected = exact
    ? `${path}/` === location.pathname ||
    path === location.pathname ||
    isBookingsPage ||
    isEventPage
    : location.pathname.startsWith(path)
  const linkProps = !external
    ? { component: NavLink, to: path }
    : { component: 'a', href: path, target: external.target || '_blank' }

  if (hide) return null

  return (
    <ExtendedListItem
      button
      onClick={onClick}
      selected={selected}
      disabled={disabled}
      {...linkProps}
    >
      <StyledListItemIcon>{iconComponent}</StyledListItemIcon>
      <ListItemText
        primary={label}
        primaryTypographyProps={{ style: { fontWeight: 500 } }}
      />
      {annotation && isTabletNavOpen && (
        <ListItemSecondaryAction>{annotation}</ListItemSecondaryAction>
      )}
    </ExtendedListItem>
  )
}
